import { defa }          from 'defa-object';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.FollowMainAlarm
 * The DEFA FollowMainAlarm model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	wiredalarm: '/wiredAlarmInput/iasZone?attrs=',
};

const FollowMainAlarm = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.wiredalarm + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			followMainIntrusionAlarmSwitch: null,
			followMainIntrusionAlarmSwitchError: null,
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			if(response.followMainIntrusionAlarmSwitch){
				this.parseAttribute('followMainIntrusionAlarmSwitch', response.followMainIntrusionAlarmSwitch, options, newModelAttributes)
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'followMainAlarms' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return { followMainIntrusionAlarmSwitch: 'ON' === this.get('followMainAlarmSwitch') };
	},
	
	getAttributes: function() {
		return 'followMainIntrusionAlarmSwitch';
	},
	
	_getDependentModels: function(){
		let self = this;
		let dependentModels = [];
		let gpai = channel.request( 'generalAlarmInputs' ).get(self.get('id'));
		dependentModels.push(gpai);
		return dependentModels;
	}
	
} );

export default FollowMainAlarm;
